<script setup>
  import { computed } from 'vue'
  import { v4 as uuidv4 } from 'uuid';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'md', // sm | md | lg
      validator: (v) => ['sm', 'md', 'lg'].includes(v)
    }
  })

  const emit = defineEmits(['update:modelValue'])
  const inputId = props.id || `switch-${uuidv4()}`
  const model = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
  })
  const sizeClass = computed(() => `switch-${props.size}`)
</script>

<template>
  <div class="form-check form-switch" :class="sizeClass">
    <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        :id="inputId"
        v-model="model"
        :disabled="disabled"
    />
    <label v-if="label" class="form-check-label ms-2" :for="inputId">{{ label }}</label>
  </div>
</template>

<style scoped>
  .form-switch {
    padding-left: 3em;
  }

  .switch-sm .form-check-input {
    transform: scale(0.85);
    margin-top: 0.15rem;
  }

  .switch-md .form-check-input {
    transform: scale(1);
  }

  .switch-lg .form-check-input {
    transform: scale(1.35);
    margin-top: 0.3rem;
  }
</style>